function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_765_47000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36 17C36 25.2843 29.2843 38 21 38C12.7157 38 6 25.2843 6 17C6 8.71573 12.7157 2 21 2C29.2843 2 36 8.71573 36 17Z",
  fill: "#50B5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 39C25.6617 39 29.6736 35.4545 32.4473 31.1481C35.2458 26.8032 37 21.368 37 17C37 8.16344 29.8366 1 21 1C12.1634 1 5 8.16344 5 17C5 21.368 6.7542 26.8032 9.55269 31.1481C12.3264 35.4545 16.3383 39 21 39Z",
  stroke: "white",
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.76 18H29V26H13V14.47L14.76 18ZM31 12H27L29 16H26L24 12H22L24 16H21L19 12H17L19 16H16L14 12H13C11.9 12 11 12.9 11 14V26C11 27.1 11.9 28 13 28H29C30.1 28 31 27.1 31 26V12Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_765_47000",
  x: 0,
  y: 0,
  width: 42,
  height: 48,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.709804 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_765_47000"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_765_47000",
  result: "shape"
})));

function SvgTransenne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransenne);
export default __webpack_public_path__ + "static/media/transenne.9f97fb0b.svg";
export { ForwardRef as ReactComponent };